import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Floor } from "./floor.model";
import { SpaceType } from "src/app/_types/space-type";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class FloorService {
  floor: Floor = new Floor();
  floors: Floor[];

  constructor(private http: HttpClient) {}

  getFloors(buildingId: number, spaceType?: SpaceType) {
    let httpParams = new HttpParams();
    if (spaceType) {
      httpParams = httpParams.set("spaceType", spaceType.toString());
    }

    return this.http.get<Floor[]>(url + "building/" + buildingId + "/floor", {
      params: httpParams,
    });
  }

  getFloor(floorId: number) {
    return this.http.get<Floor>(url + "building/" + 0 + "/floor/" + floorId);
  }

  deleteFloor(floorId: number) {
    return this.http.delete(url + "building/" + 0 + "/floor/" + floorId);
  }

  addFloor(buldingId: number, floor) {
    return this.http.post(url + "building/" + buldingId + "/floor/", floor);
  }

  updateFloor(buldingId: number, floorId: number, floor) {
    return this.http.put(
      url + "building/" + buldingId + "/floor/" + floorId,
      floor
    );
  }
}
